import React from 'react';

import { StyledImage } from './Image';

export const Image = props => {
  const { url, alt } = props;

  return <StyledImage url={url} alt={alt} {...props} />;
};
